import styled from 'styled-components';

const Label = styled.label`
  display: inline-block;
  line-height: 1.4285714;
  font-weight: bold;
`;

export default Label;
